export default __webpack_public_path__ + "static/media/logofooter.fc1f5849.png";